
<!-- begin:: Page -->
<ng-container >
	<!-- begin:: Header Mobile -->
	<kt-header-mobile></kt-header-mobile>
	<!-- end:: Header Mobile -->

	<div class="kt-grid kt-grid--hor kt-grid--root">
		<!-- begin::Body -->
		<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">

		

			

			<div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
				<!-- begin:: Header -->
			
				<!-- end:: Header -->

				<!-- begin:: Content -->
				<div class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_body">
					
						<!-- begin:: Content Head -->
						<!-- <kt-subheader6></kt-subheader6> -->
						<!-- end:: Content Head -->

						<!-- begin:: Content Body -->
						<div ktContentAnimate class="kt-container kt-grid__item kt-grid__item--fluid" [ngClass]="{'kt-container--fluid': true}">

								<router-outlet></router-outlet>
							
						</div>
						<!-- end:: Content Body -->
					</div>
				
				<!-- end:: Content -->

				
			</div>
		</div>
		<!-- end:: Body -->

		

		<!-- ### Sag taragtaki tema ve dokuman menusu - Hasan ### -->
		<!-- <kt-sticky-toolbar></kt-sticky-toolbar> -->
	</div>
</ng-container>
<!-- end:: Page -->

<ng-template #blankLayout>
	<router-outlet></router-outlet>
</ng-template>
